import React, {useEffect, useState} from "react";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";

function ThumbFetch(props) {

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [item, setItem] = useState({});

    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    useEffect(() => {
        fetch('https://freesound.org/apiv2/sounds/' + props.id + '/?&token=' + global.KEY)
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItem(result.images.waveform_l);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, [props.id])

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div><Spinner animation="border"/> Loading...</div>;
    } else {

        return (
            <div className="ThumbFetch">
                <Card.Img variant="top" src={item} alt="Wave form"/>
            </div>
        );
    }
}

export default ThumbFetch;